export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ShouldSupportTimeSlotsInCheckout: 'specs.stores.ShouldSupportTimeSlotsInCheckout',
  AddLocaleAsAControllerParam: 'specs.stores.AddLocaleAsAControllerParam',
  NoFastFlowRedirectOnShippingInfoCollected: 'specs.stores.NoFastFlowRedirectOnShippingInfoCollected',
  SupportSuccessUrlParamInCheckout: 'specs.stores.SupportSuccessUrlParamInCheckout'
};
//# sourceMappingURL=SPECS.js.map